import React from "react";
import { Link } from 'react-router-dom';
import {
  Button,
  Table,
  TableContainer,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  Chip
} from "@material-ui/core";
import useStyles from "./styles";

const states = {
  ready: "success",
  processing: "warning",
  errored: "secondary",
  complete: "info"
};

const KEY_ARRAY= ['Name','UpdatedAt', 'Description', 'Status', 'StatusText', 'Details'];

export default function TableComponent({ onStarClick, data }) {

  const classes = useStyles();
  if(!Array.isArray(data) || !data.length || !data[0]) {
    return (null);
  }

  const sortedData = data.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));

  return (
    <TableContainer>
    <Table className="mb-0">
      <TableHead>
        <TableRow>
          {KEY_ARRAY.map(key => (
            <TableCell style={{
            }} key={key}>{key}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {sortedData.map(({ videoId, updatedAt, name, description, status, statusText }) => (
          <TableRow key={videoId}>
            <TableCell>{name}</TableCell>
            <TableCell>{updatedAt}</TableCell>
            <TableCell>{description}</TableCell>
            <TableCell>
              <Chip label={status} classes={{root: classes[states[status.toLowerCase()]]}}/>
            </TableCell>
            <TableCell>{statusText}</TableCell>
            <TableCell>
              <Button
                component={Link}
                to={`/videos/${videoId}`}
                variant={"contained"}
                color="primary">
                  Details
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
    </TableContainer>
  );
}
